import { withTheme } from '@material-ui/core';
import React from 'react';
// this component is use for creating SVG to show RouteCompliance

const Circle = ({ color, percentageCount, theme }) => {
  const r = 55;
  const cir = 2 * Math.PI * r;
  const strokePct = ((100 - percentageCount) * cir) / 100;
  return (
    <circle
      r={r}
      cx={75}
      cy={75}
      fill="transparent"
      stroke={strokePct !== cir ? color : ''} // remove color as 0% sets full circumference
      strokeWidth={theme.textFontSize}
      strokeDasharray={cir}
      strokeDashoffset={percentageCount ? strokePct : 0}
      strokeLinecap="round"></circle>
  );
};

const Text = ({ percentage, theme }) => {
  return (
    <text
      x="50%"
      y="50%"
      dominantBaseline="central"
      textAnchor="middle"
      fontSize={'36px'}
      fill={theme.HeaderSelectedText}>
      {percentage.toFixed(0)}%
    </text>
  );
};

const RouteCompliance = ({ percentage, theme }) => {
  return (
    <svg width={150} height={150}>
      <g transform={`rotate(-90 ${'75 75'})`}>
        <Circle color={theme.AppBGColor} theme={theme} />
        <Circle color={theme.HeaderSelectedText} percentageCount={percentage} theme={theme} />
      </g>
      <Text percentage={percentage} theme={theme} />
    </svg>
  );
};

export default withTheme()(RouteCompliance);
